import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 px-4 bg-black text-white border-t-4 border-yellow-400" data-id="element-55">
      <div className="max-w-3xl mx-auto text-center" data-id="element-56">
        <div data-id="element-57">
          <ShieldCheckIcon className="w-16 h-16 text-yellow-400 mx-auto mb-5" data-id="element-58" />

          <h2 className="text-2xl md:text-4xl font-black text-white mb-6 uppercase tracking-wide" data-id="element-59">
            🔒 GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="text-base md:text-lg text-gray-300 space-y-3 mb-10 max-w-2xl mx-auto font-medium" data-id="element-60">
            <p data-id="element-61">Probalo durante 7 días completos.</p>
            <p data-id="element-62">Si no es para vos, te devolvemos el 100% del dinero.</p>
            <p className="text-yellow-400 font-bold" data-id="element-63">
              Sin preguntas. Sin letra chica. Sin riesgo.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-5 md:p-6 rounded-xl mb-10 shadow-lg" data-id="element-64">
            <h3 className="text-xl md:text-2xl font-black text-red-500 mb-4" data-id="element-65">
              ❤️ La conexión no se posterga
            </h3>
            <div className="space-y-2 text-base" data-id="element-66">
              <p className="font-bold text-white" data-id="element-67">
                No necesitás más tiempo. Necesitás mejores momentos.
              </p>
              <p className="text-gray-400" data-id="element-68">
                Tus hijos no van a ser chicos para siempre.
              </p>
              <p className="text-gray-400" data-id="element-69">
                Las preguntas que te hacen hoy, mañana ya no te las van a hacer.
              </p>
              <p className="text-gray-400" data-id="element-70">
                Los abrazos que te piden ahora, un día van a dejar de pedirlos.
              </p>
              <p className="text-yellow-400 font-bold text-lg mt-3" data-id="element-71">
                Hoy todavía estás a tiempo de crear esos recuerdos.
              </p>
              <p className="text-gray-500 italic text-sm mt-2" data-id="element-72">
                Dentro de unos años vas a agradecer haber tomado esta decisión.
              </p>
            </div>
          </div>

          <CTAButton text="👉 QUIERO CREAR RECUERDOS QUE DUREN PARA SIEMPRE" data-id="element-73" />
        </div>
      </div>
    </section>;
}